import { render, staticRenderFns } from "./PrintJournalKasbonExternal.vue?vue&type=template&id=a15049b4"
import script from "./PrintJournalKasbonExternal.vue?vue&type=script&lang=js"
export * from "./PrintJournalKasbonExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports